// extracted by mini-css-extract-plugin
export default {"text":"views-CheckoutPage-ContactInfo-themes-BGH-RD3-leaveMessage__text--V5TLg","length":"views-CheckoutPage-ContactInfo-themes-BGH-RD3-leaveMessage__length--x3hrN"};